@if (isLoading) {
  <div style="padding: 40px; text-align: center;">Loading master mix ticket...</div>
}
@if (!isLoading && !data) {
  <div style="padding: 40px; text-align: center; color: #8c8c8c;">
    Master Mix Ticket data endpoint not yet implemented (Plan 4 Task 6).
    <br>Batch: {{ masterMixBatchNumber }}
  </div>
}
@if (data) {
<div class="ticket-page">
  <app-print-company-header title="Master Mix Ticket">
    <div class="batch-qr">
      <nz-qrcode [nzValue]="data.MasterMixBatchNumber" [nzSize]="96" [nzBordered]="false" [nzLevel]="'M'"></nz-qrcode>
      <div class="batch-no">{{ data.MasterMixBatchNumber }}</div>
    </div>
  </app-print-company-header>

  <table class="metadata-table">
    <tr>
      <td class="meta-label">Sale {{ (data.SaleOrderNumbers?.length ?? 0) > 1 ? 'Orders' : 'Order' }}</td>
      <td class="meta-value" colspan="3"><b>{{ data.SaleOrderNumbers?.length ? data.SaleOrderNumbers.join(', ') : '—' }}</b></td>
    </tr>
    <tr>
      <td class="meta-label">Vessel</td>
      <td class="meta-value">{{ data.VesselTag }} / {{ data.VesselName }}</td>
      <td class="meta-label">Date</td>
      <td class="meta-value">{{ data.TicketDate | DatetimeConverter }}</td>
    </tr>
    <tr>
      <td class="meta-label">Formulation</td>
      <td class="meta-value">{{ data.FormulationCode }}</td>
      <td class="meta-label">Mixing Stage</td>
      <td class="meta-value">{{ mixingLabel }}</td>
    </tr>
    <tr>
      <td class="meta-label">GSM</td>
      <td class="meta-value">{{ data.Gsm ?? '—' }}</td>
      <td class="meta-label">Total Paste Qty</td>
      <td class="meta-value"><b>{{ data.TotalPasteQuantity | number:'1.2-2' }} Kg</b></td>
    </tr>
    <tr>
      <td class="meta-label">Vessel Tare</td>
      <td class="meta-value">@if (data.VesselTareWeightKg != null) { {{ data.VesselTareWeightKg | number:'1.2-2' }} Kg } @else { Not Provided }</td>
      <td class="meta-label">Weight with vessel</td>
      <td class="meta-value">
        @if (data.ExpectedGrossWeightKg != null) {
          <b>{{ data.ExpectedGrossWeightKg | number:'1.2-2' }} Kg</b>
          (tare + {{ data.RemainingInVessel | number:'1.2-2' }} Kg paste in vessel)
        } @else { Not Provided }
      </td>
    </tr>
    @if (data.UseByDate) {
      <tr>
        <td class="meta-label">Use by</td>
        <td class="meta-value" colspan="3">{{ data.UseByDate | DatetimeConverter }}</td>
      </tr>
    }
  </table>

  <table class="materials-table">
    <thead>
      <tr>
        <th>S.No</th>
        <th>Material</th>
        <th>Batch</th>
        <th>Supplier</th>
        <th>Required (Kg)</th>
        <th>{{ data.IsWeighed ? 'Weighed (Kg)' : 'Allocated (Kg)' }}</th>
      </tr>
    </thead>
    <tbody>
      @for (m of data.Materials; track $index) {
        <tr>
          <td>{{ $index + 1 }}</td>
          <td>{{ m.ProductName }}</td>
          <td>{{ m.Batch }}</td>
          <td>{{ m.SupplierName }}</td>
          <td>{{ m.RequiredQuantity | number:'1.2-2' }}</td>
          <td><b>{{ m.AllocatedQuantity | number:'1.2-2' }}</b></td>
        </tr>
      }
    </tbody>
  </table>

  @if (data?.UnplannedAdditions?.length) {
    <table class="materials-table" style="margin-top: 8px;">
      <thead>
        <tr class="materials-header">
          <th>S.No</th><th>Unplanned RM addition</th><th>Batch</th><th>Quantity (kg)</th><th>Unit</th>
        </tr>
      </thead>
      <tbody>
        @for (a of data.UnplannedAdditions; track $index; let i = $index) {
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ a.ProductName }}<div style="font-size: 10px; color: #595959;">{{ a.ReasonLabel }} · {{ a.AddedDate | DatetimeConverter }} · {{ a.AddedByName }}</div></td>
            <td>@for (b of a.Batches; track $index) { <div>{{ b }}</div> } @empty { — }</td>
            <td>{{ a.Quantity | number:'1.2-2' }}</td>
            <td>{{ a.Unit }}</td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (data.ChildTickets?.length) {
    <h4 class="section-title">Drawn into child tickets</h4>
    <table class="materials-table">
      <thead>
        <tr>
          <th>Child ticket</th>
          <th>To vessel</th>
          <th>Orders</th>
          <th>Paste (Kg)</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        @for (c of data.ChildTickets; track c.MixingChildTicketNumber) {
          <tr>
            <td>{{ c.MixingChildTicketNumber }}</td>
            <td>{{ c.DestinationVesselTag }}</td>
            <td>{{ c.SaleOrderNumbers.join(', ') }}</td>
            <td><b>{{ c.TransferredQuantity | number:'1.2-2' }}</b></td>
            <td>{{ c.TransferredDate | DatetimeConverter }}</td>
          </tr>
        }
      </tbody>
    </table>
    <div class="remaining-line">Remaining in this vessel: <b>{{ data.RemainingInVessel | number:'1.2-2' }} Kg</b></div>
  }

  <div class="supervisor">
    @if (data.SupervisorName) {
      <div>Mixed by: {{ data.SupervisorName }}</div>
    }
    <div class="signature-line">Signature: ____________________</div>
  </div>
  <app-print-footer audience="internal"></app-print-footer>
</div>
}
